import { Component } from '@angular/core';
import { AmorphicService } from '../../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { AccountCenterService } from '../../../../../../coverpath-common/angular/services/account-center/account-center.service';
import { ModalService } from '../../../../../../coverpath-common/angular/services/modal/modal.service';
import { BasePolicyBannerComponent } from '../../../../../../coverpath-common/angular/components/account-center/policy-banner/base-policy-banner.component';
import { CoverpathPolicyStatus } from '../policy-status/policy-status';
import type { CoverpathPolicy } from '../../../../../../coverpath-common/classes/coverpath_subclasses/CoverpathPolicy';
import { AccountCenterController } from '../../../amorphicControllers/AccountCenterController';
import { CoverpathUtils } from '../../../../../../coverpath-common/js/static/CoverpathUtils';
import { ToastService } from '../../../../../../coverpath-common/angular/components/overlays/toaster/toast-service.service';

@Component({
  selector: 'policy-banner',
  moduleId: module.id,
  templateUrl: './policy-banner.component.html',
})
export class PolicyBannerComponent extends BasePolicyBannerComponent {
  async ngOnInit(): Promise<void> {
    this.subscribeToAccountCenterService();
    this.isLoading = false;
    await this.setAllProperties();
    this.isLoading = false;
  }

  constructor(
    amorphicService: AmorphicService,
    accountCenterService: AccountCenterService,
    private modalService: ModalService,
    private toastService: ToastService
  ) {
    super(amorphicService, accountCenterService, modalService, toastService);
    this.policyStatus = new CoverpathPolicyStatus(
      this.amorphicService,
      this.amorphicService.controller.customer.application.primaryPolicy as CoverpathPolicy,
      accountCenterService
    );
  }

  async setAllProperties(): Promise<void> {
    await super.setAllProperties();
    this.insuredEsignRequired = CoverpathUtils.isInsuredSignRequiredAtFinalAcceptance(this.policy);
  }

  async acceptOffer(): Promise<void> {
    this.isLoading = true;
    await super.acceptOffer();
  }

  resendInsuredEsignEmail() {
    this.isLoading = true;
    setTimeout(() => {
      this.isLoading = false;
    }, 3000); // TODO: HL-7682 Update with modal notification upon action success
    this.accountCenterService.resendInsuredEsignEmail();
  }
}
